import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Button, CircularProgress, Container, Typography } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getBuscarCategoria, getCategorias } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import { CssTextField } from "../../../styles/styles";
import CategoriasHeader from "./components/CategoriasHeader";
import CategoriasFiltrosComponents from "./components/CategoriasFiltrosComponents";
import CategoriasTableComponent from "./components/CategoriasTableComponent";



function CategoriasPage() {
  const [loading, setLoading] = useState(false);
  const [dataCategorias, setDataCategorias] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [cargando, setCargando] = useState(false);
  const [metaPaginacion, setMetaPaginacion] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [perPage, setPerPage] = useState(10);
  const [loadingCargar, setLoadingCargar] = useState(false);



  let history = useNavigate();

  const stateToken = useSelector(state => state.reducerGlobal.token);



  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (titulo.length > 2) {

        handleApiFiltrarCategoriasTituloEstado(titulo);
      } else {
        handleApiFiltrarCategorias(1);
      }
    }, 1500);
    return () => clearTimeout(timeOutId);
  }, [stateToken, titulo, perPage]);






  //============================================================ funcion para filtrar por estado y nombre
  const handleApiFiltrarCategoriasTituloEstado = (titulo) => {

    let body = {
      page: 1,
      per_page: perPage,
      titulo: titulo
    };
    console.log("body-handleApiFiltrarLocales", body);


    setLoadingCargar(true);

    getBuscarCategoria(stateToken?.access_token, body)
      .then(response => {
        // console.log("response==>getCategorias", response);

        setLoadingCargar(false);
        // setMetaPaginacion(response.meta);

        if (response?.data?.data?.length > 0) {
          setDataCategorias(response?.data?.data);
          setLoading(true);
        } else {
          setDataCategorias([]);
          setLoading(true);
        }

        setMetaPaginacion({
          current_page: response?.data?.current_page,
          per_page: response?.data?.per_page,
          total: response?.data?.total,
          last_page: response?.data?.last_page
        });


      })
      .catch(error => {
        console.log("error==>getCategorias", error);
        setDataCategorias([]);
        setLoading(true);
        setLoadingCargar(false);
      })
  };



  //============================================================ funcion para filtrar por estado y nombre
  const handleApiFiltrarCategorias = (page = 1) => {

    let body = {
      page: page,
      per_page: perPage,
      titulo: titulo,
    };
    // console.log("body-handleApiFiltrarLocales", body);


    setLoadingCargar(true);

    getBuscarCategoria(stateToken?.access_token, body)
      .then(response => {
        console.log("response==>getFiltrarEventos", response?.data);

        setLoadingCargar(false);

        if (response?.data?.data?.length > 0) {
          setDataCategorias(response?.data?.data);
          setLoading(true);
        } else {
          setDataCategorias([]);
          setLoading(true);
        }

        setMetaPaginacion({
          current_page: response?.data?.current_page,
          per_page: response?.data?.per_page,
          total: response?.data?.total,
          last_page: response?.data?.last_page
        });


      })
      .catch(error => {
        console.log("error==>getFiltrarEventos", error);
        setDataCategorias([]);
        setLoading(true);
        setLoadingCargar(false);
      })
  };









  //=================================================================================================funcion para ir a la pantalla de agregar
  const handleAddCategoria = () => {
    history('/app/admin/locales-categorias-add', { state: null });
  };






  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
  };


  const handleEditarItem = (item) => {
    console.log("item a editar==>", item);

    history(`/app/admin/locales-categoria/${item?.id}`, { state: null });

  };


  return (
    <HeaderCustom>
      <div className="min-h-screen bg-gray-100 p-6">
        {loading ? (
          <div className="max-w-7xl mx-auto">

            <CategoriasHeader
              title="Categorías"
              subtitle="Administra y supervisa las categorías de la plataforma."
              handleAdd={handleAddCategoria}
            />


            <div>
              <CategoriasFiltrosComponents
                searchValue={titulo}
                onSearchChange={setTitulo}
              // statusFilter={statusFilter}
              // onStatusChange={handleStatusChange}
              // statusOptions={statusOptions}
              />


              <CategoriasTableComponent
                data={dataCategorias}
                metaPaginacion={metaPaginacion}
                onPageChange={handleApiFiltrarCategorias}
                perPage={perPage}
                onPerPageChange={handlePerPageChange}
                handleEditarItem={handleEditarItem}
              // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
              />

            </div>





          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
            <div className="space-y-4">
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-24 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        )}


        <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </HeaderCustom>
  );
}
export default CategoriasPage;